/**
 * Finds a "friendly" URL key from a printer map given a target value.
 *
 * This function attempts to match the provided target to a key in the printerMap object.
 *
 * If the target matches a key (after trimming and removing leading/trailing slashes), that key is returned.
 * If not, it searches for the target as a value in the printerMap and returns the corresponding key if found.
 * If no match is found, the cleaned target is returned.
 *
 * @param {Object.<string, string>} printerMap - An object mapping friendly URL keys to printer values.
 * @param {string} target - The target string to find in the printerMap, either as a key or value.
 * @returns {string} The matching key from the printerMap, or the cleaned target if no match is found.
 */
const findFriendlyURL = (printerMap, target) => {
  const cleanTarget = String(target).trim().replace('/', '')

  // Check if target is a key
  if (Object.prototype.hasOwnProperty.call(printerMap, cleanTarget)) {
    return cleanTarget
  }

  // Search for the target as a value
  for (let key in printerMap) {
    if (printerMap[key] === cleanTarget) {
      return key
    }
  }

  // Return original if not found
  return cleanTarget
}

export default findFriendlyURL
